<template>
  <section class="page-left-side">
    <el-menu
      :default-active="$route.path"
      v-for="(item, index) in menuList"
      :key="index"
      router
    >
      <el-sub-menu :index="'' + index" v-if="item?.children?.length > 0">
        <template #title>
          <el-icon><component :is="item.icon"/></el-icon>
          <span>{{ item.title }}</span>
        </template>
        <template v-if="item.children">
          <el-menu-item v-for="(_item, _index) in item.children" :key="_index" :index="_item.path" :disabled="_item.disabled">{{ _item.title }}</el-menu-item>
        </template>
      </el-sub-menu>
      <el-menu-item :index="item.path" :disabled="item.disabled" v-else>
        <template #title>
          <el-icon><component :is="item.icon"/></el-icon>
          <span>{{ item.title }}</span>
        </template>
      </el-menu-item>
    </el-menu>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import { Document, Notebook, Tickets, Goods, Collection,User } from '@element-plus/icons-vue'

const menuList = ref([
  {
    title: '数据概览', icon: Tickets,
    children: [
      { title: '销售数据', path: '/crm/sellBoard/list' },
      { title: '客户管理', path: '/crm/list' },
      { title: '客户数据', path: '/crm/dashBoard/list' },
    ]
  },
  {
    title: '商品管理', icon: Goods,
    children: [
      { title: '商品列表', path: '/commodity/list' },
    ]
  },
  {
    title: '订单管理', icon: Tickets,
    children: [
      { title: '订单列表', path: '/order/list' },
    ]
  },
  {
    title: '分销管理', icon: Tickets,
    children: [
      { title: '分销员列表', path: '/agency/list' },
      { title: '提现申请列表', path: '/application/list' },
      { title: '钱包列表', path: '/wallet/list' },
    ]
  },
  {
    title: '用户管理', icon: User,
    children: [
      { title: '用户列表', path: '/user/list' },
    ]
  },
  // {
  //   title: '广告位管理', icon: Collection,
  //   children: [
  //     { title: '广告位列表', path: '/banner/list' },
  //   ]
  // },
  {
    title: '系统管理', icon: Notebook,
    children: [
      { title: '管理员列表', path: '/admin/list' },
      { title: '系统配置', path: '/system/settings' },
    ]
  },
])

</script>

<style scoped lang="less">
  @import "index.less";
</style>
